// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"731":"821de616","799":"951e9cca","935":"5a07c246"}[chunkId] + ".css";
};